var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:`media-library-button media-library-button-${_vm.level}`},[_c('icon',{attrs:{"icon":_vm.icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }